import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "ml-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalPopover = _resolveComponent("BalPopover")!

  return (_openBlock(), _createBlock(_component_BalPopover, {
    align: "left",
    "no-pad": ""
  }, {
    activator: _withCtx(() => [
      _createVNode(_component_BalBtn, {
        color: "white",
        size: _ctx.upToLargeBreakpoint ? 'md' : 'sm',
        class: "ml-4"
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.iconSrc(_ctx.activeNetwork),
            alt: _ctx.activeNetwork.name,
            class: "w-5 h-5 rounded-full shadow-sm"
          }, null, 8, _hoisted_1),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.activeNetwork.name), 1)
        ]),
        _: 1
      }, 8, ["size"])
    ]),
    _: 1
  }))
}